<template>
  <div v-if="image" class="Mw-PostLogin-thankyou-custom-image">
    <img :src="image.url" alt="" />
  </div>
</template>

<script>
  export default {
    props: {
      option: {
        type: Array,
      },
    },
    computed: {
      image() {
        const actionName = 'Add Image'
        return this.option.find((a) => a.action === actionName)
      },
    },
  }
</script>

<style scoped lang="scss">
  .Mw-PostLogin-thankyou-custom-image {
    padding: 20px;
    img {
      max-width: 100%;
    }
  }
</style>
